<template>
  <div>
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="name"
      :ui-title="title"
      :presence="presence"
    >
      <UiWrapper
        :name="FIELD_NAMES.birthDate"
        :label="label"
        :validations="validations"
      >
        <DateWrapper />
      </UiWrapper>
    </FieldsetModel>
  </div>
</template>

<script>

import DateWrapper from '@/forms/components/ui-dunia/date-wrapper';
import * as conditions from '@/forms/conditions';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';

import { MIN_AGE, MAX_AGE } from '@/forms/constants/onboarding-logic';

import FIELDSET_NAMES from '@/forms/constants/fieldset-names';

export default {
  name: 'FieldsetBornDate',

  props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.bornDate,
    },
    title: {
      type: String,
      default: 'Your date of birth',
    },
    label: {
      type: String,
      default: 'dd/mm/yyyy',
    },
    validations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a past date',
          condition: conditions.isPastDateCondition,
          name: 'birth-is-pastdate',
        },
        // {
        //   errorMessage: 'You must be under 60 years old',
        //   condition: conditions.maxYearCondition(MAX_AGE),
        //   name: 'age-is-under-60',
        // },
        {
          errorMessage: 'You must be at least 21 years old',
          condition: conditions.minYearCondition(MIN_AGE),
          name: 'age-is-above-21',
        },
      ]),
    },
    presence: {
      type: Boolean,
      default: true,
    },
  },

  mixins: [sharedComponentMixin],

  components: {
    DateWrapper,
  },

};



</script>





